import React from "react";
import PropTypes from "prop-types";
import Legends from "../../common/Legends";

function Options(props) {
  const {
    options,
    currentOptions,
    productName,
    category,
    department,
    compact
  } = props;
  return options
    ? options.map(({name, content}) =>
        Legends[name]
          ? React.createElement(Legends[name], {
              key: name,
              productName,
              category,
              department,
              name,
              content,
              current: currentOptions[name],
              compact,
              onChange: props.changeOption
            })
          : null
      )
    : null;
}

Options.propTypes = {
  productName: PropTypes.string,
  department: PropTypes.string,
  category: PropTypes.string,
  options: PropTypes.array,
  currentOptions: PropTypes.object,
  compact: PropTypes.bool,
  changeOption: PropTypes.func
};

export default Options;
